@if (showHeader) {
  <div class="app" [style.background-image]="'url(' + imgSrc + ')'"></div>
  <mat-toolbar id="header">
    @if (circleImgSrc) {
      <div
        [style.background-image]="'url(' + circleImgSrc + ')'"
        class="avatar"
      ></div>
    }
    @if (headerTitle() === appName) {
      <span id="brand-header" class="mlr logo-family">
        {{ headerTitle() }}
      </span>
    } @else {
      <span id="plain-header" class="mlr plain-family">
        {{ headerTitle().toUpperCase() }}
      </span>
    }

    <span class="spacer"></span>
    <button mat-icon-button class="mlr" (click)="logout()">
      <mat-icon>logout</mat-icon>
    </button>
  </mat-toolbar>
  @if (showFooter) {
    <mat-toolbar id="footer">
      <span class="mlr logo-family"> {{ appName }} </span>
    </mat-toolbar>
  }
}

<div class="page-content" [class.login]="!showHeader">
  <router-outlet />
</div>
